import PropTypes from 'prop-types'
import React  from 'react'
import TimeUtil from 'utils/time-util'
import { Button, Badge } from 'reactstrap'

const propTypes = {
  scheduledTemplate     : PropTypes.object,
  onClickCancelScehdule : PropTypes.func
  // onClickReschedule     : PropTypes.func // TODO: waiting for api reschedule template
}

const defaultProps = {
  scheduledTemplate     : {},
  onClickCancelScehdule : () => {}
  // onClickReschedule     : () => {} // TODO: waiting for api reschedule template
}

const NotificationTemplateTableRow = ({
  scheduledTemplate,
  onClickCancelScehdule
  // onClickReschedule //TODO: waiting for api reschedule template
}) => {
  const {
    id,
    name,
    scheduled_date,
    has_push_notification,
    receiver_size // custom attribute in serializer
  } = scheduledTemplate

  const buttonClassName = 'align-self-center my-2'

  const hasChannelsWhatsapp =  scheduledTemplate.whatsapp !== null
  const hasTlMessage        = scheduledTemplate.tinkerlust !== null
  const hasPushNotification = has_push_notification !== null

  const TEMPLATE_CHANNELS = [
    { name: 'Whatsapp', visible: hasChannelsWhatsapp },
    { name: 'Tinkerlust', visible: hasTlMessage },
    { name: 'Push Notification', visible: hasPushNotification }
  ]

  return (
    <tr>
      <td>
        { id }
      </td>
      <td>
        { name }
      </td>
      <td>
        {
          TEMPLATE_CHANNELS.filter((channel) => channel.visible)
            .map((channel) => (
              <div key={ `channel-${channel.name}` }>
                <Badge color='default'>
                  { channel.name }
                </Badge>
              </div>
            ))
        }
      </td>
      <td>
        { TimeUtil.format(scheduled_date, 'DD MMM YYYY HH:mm') }
      </td>
      <td>
        { receiver_size }
      </td>
      <td className="d-flex flex-column bd-highlight mb-3">
        <Button
          size='sm'
          color={ 'danger' }
          className={ buttonClassName }
          onClick={ () => onClickCancelScehdule(scheduledTemplate) }
        >
          { 'Cancel Scheduled' }
        </Button>

        { /* TODO: waiting for api reschedule template */ }
        { /* <Button
          size='sm'
          color={ 'primary' }
          className={ buttonClassName }
          onClick={ onClickReschedule }
        >
          { 'Reschedule' }
        </Button> */ }

      </td>
    </tr>
  )
}



NotificationTemplateTableRow.propTypes    = propTypes
NotificationTemplateTableRow.defaultProps = defaultProps

export default NotificationTemplateTableRow
